var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhotos = function SvgPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9d1b",
    stroke: "#3da1db",
    strokeWidth: 4,
    d: "M23.315 18.037a2 2 0 0 0-1.5.306 2 2 0 0 0-.845 1.276l-7.633 39.265a2 2 0 0 0 .306 1.5 2 2 0 0 0 1.276.845l45.155 8.777a2 2 0 0 0 1.5-.305c.424-.286.74-.734.845-1.276l7.63-39.265a1.994 1.994 0 0 0-1.581-2.345l-45.155-8.778z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3da1db",
    d: "M58 8a4 4 0 0 1 4 4v40a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50cdff",
    d: "M58 12H12v40h46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3da1db",
    d: "M35 34a9 9 0 1 0 0-18 9 9 0 1 0 0 18m0 4.5c-6.008 0-18 3.015-18 9V54h36v-6.5c0-5.985-11.992-9-18-9"
  })))));
};
export default SvgPhotos;